import { useUserStore } from "@/stores/user";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore();
  await userStore.validate();

  if (to.name == "country-locale-bespoke-and-project-consultancy") {
    return;
  }

  if (
    to.name == "country-locale-bespoke-and-project-consultancy-id" &&
    !userStore.logged
  ) {
    return;
  }

  if (!userStore.logged) {
    return navigateTo(`/${to.params.country}/${to.params.locale}`, {
      external: true,
    });
  } else if (userStore.user.type === "professional") {
    const enabledTitles = [
      "Architect",
      "Engineer",
      "Interior Designer / Planner",
      "Landscape / Hardscape Designer",
      "Construction Company / General Contractor",
    ];
    if (enabledTitles.indexOf(userStore.user.title) === -1) {
      return navigateTo(
        `/${to.params.country}/${to.params.locale}/bespoke-and-project-consultancy/form`,
        {
          external: true,
        }
      );
    }
  } else {
    return navigateTo(
      `/${to.params.country}/${to.params.locale}/support/private-commercial-consultancy`,
      {
        external: true,
      }
    );
  }
});
